import { Component, Input, OnInit, inject } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { Store } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { TeamStore } from "@app/services/store/team-store";
import { ResourceStore } from "@app/services/store/resource-store";
import { Team } from "@app/models/rest/team";
import { firstValueFrom } from "rxjs";
import { ResourceModel } from "@app/models/rest/resource";
import { ResourceCollection } from "@lagoshny/ngx-hateoas-client";
import { ColumnConfig, DateColumnConfig } from "@bryntum/grid-thin";
import { Planner } from "@app/models/rest/planner";
import { MatButton } from "@angular/material/button";
import { GridComponent } from "../../../../shared/base-pages/base-data-table-page/grid.component";

@Component({
  selector: "app-team-detail",
  templateUrl: "./team-detail.component.html",
  styleUrls: ["./team-detail.component.scss"],
  imports: [MatButton, RouterLink, GridComponent]
})
export class TeamDetailComponent implements OnInit {
  teamStore = inject(TeamStore);
  resourceStore = inject(ResourceStore);
  router = inject(Router);
  protected store = inject<Store<any>>(Store);
  protected dialog = inject(MatDialog);

  @Input()
  public teamId: number;
  protected team: Team;
  protected resourceList: Array<ResourceModel>;
  resourceColumns: (ColumnConfig | DateColumnConfig)[] = [
    {
      field: "name",
      text: "Name",
      filterable: true
    }
  ];
  plannerColumns: (ColumnConfig | DateColumnConfig)[] = [
    {
      field: "displayName",
      text: "Name",
      filterable: true
    }
  ];
  protected plannerList: Array<Planner>;

  ngOnInit() {
    this.teamStore.loadSingle(this.teamId, true).then((value) => {
      this.team = value;
      firstValueFrom(
        this.team.getRelatedCollection<ResourceCollection<ResourceModel>>(
          "resourceList",
          { params: { projection: "detail" } }
        )
      ).then((resources) => {
        this.resourceList = resources.resources;
      });

      firstValueFrom(
        this.team.getRelatedCollection<ResourceCollection<Planner>>(
          "plannerList",
          { params: { projection: "detail" } }
        )
      ).then((resources) => {
        this.plannerList = resources.resources;
      });
    });
  }
}
